import React, { useState, useEffect } from "react";
import Dropzone from "../../components/Dropzone";
import { Link, useParams, useNavigate } from "react-router-dom";
import { getLocalDate, getToken, URL } from "../../utils";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import NumberInput from "../../components/NumberInput";

export default function EditProduct() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = getToken();

  const [newProduct, setNewProduct] = useState({
    nom: "",
    quantite: "",
    seuil: "",
    unite: "",
    prix_achat: "",
    prix_vente_emporte: "",
    prix_vente_sur_place: "",
    nom_categorie: "",
    nom_magasin: "",
  });

  const [data, setData] = useState([]);

  useEffect(() => {
    fetchProduct();
    if (newProduct.nom_categorie) {
      fetchData();
    }
  }, []);

  const fetchProduct = async () => {
    try {
      const response = await axios.get(
        URL + `Magasins/detail-stock_item/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data) {
        setNewProduct(response.data);
      }
    } catch (err) {
      if (err.response) {
        toast.error("Erreur lors de la récupération des données:");
      } else if (err.request) {
        toast.error("Aucune réponse reçue:");
      } else {
        toast.error("Erreur de connexion");
      }
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(
        URL + "Magasins/categories-list/" + newProduct.nom_categorie,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setData(response.data);
    } catch (err) {
      console.error(err);
      if (err.response) {
        toast.error("Erreur lors de la récupération des données:");
      } else if (err.request) {
        toast.error("Aucune réponse reçue:");
      } else {
        toast.error("Erreur:", err.message);
      }
    }
  };

  const handleUpdateProduct = (e) => {
    e.preventDefault();
    axios
      .put(URL + `Magasins/edit-product/${id}`, newProduct, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        toast.success("Produit mis à jour avec succès:");
        navigate(
          `/stock/sell-point-details/${
            newProduct.nom_magasin.split(" - ")[0]
          }/category/${newProduct.nom_categorie}`,
        );
      })
      .catch((err) => {
        if (err.response) {
          toast.error(
            "Erreur lors de la mise à jour du produit:",
            err.response.data,
          );
        } else if (err.request) {
          toast.error("Aucune réponse reçue:", err.request);
        } else {
          toast.error("Erreur:", err.message);
        }
      });
  };

  return (
    <>
      <ToastContainer />
      <div className="flex-grow col-span-1 bg-white shadow-md mx-auto max-w-2xl m-4 rounded-md">
        <img
          src="https://i.pinimg.com/736x/78/16/50/781650001b4c216959d8d5bcac8bb2e5.jpg"
          alt="Description de l'image"
          className="max-h-56 w-full object-cover rounded-t-lg"
        />
        <h1 className="text-xl font-medium py-2 px-4 flex items-center justify-between">
          Modification d'un produit
          <span className="text-sm text-gray-400 capitalize">
            {getLocalDate()}
          </span>
        </h1>
        <div className="p-4">
          <form onSubmit={handleUpdateProduct} className="space-y-4 text-sm">
            <div className="space-y-1">
              <label htmlFor="nom">Nom</label>
              <input
                type="text"
                id="nom"
                value={newProduct.nom}
                onChange={(e) =>
                  setNewProduct({ ...newProduct, nom: e.target.value })
                }
                className="w-full border p-2.5 rounded"
              />
            </div>
            <div className="flex gap-4">
              <div className="flex-grow space-y-1">
                <label htmlFor="quantite">Quantité</label>
                <NumberInput
                  id="quantite"
                  name="quantite"
                  value={newProduct.quantite}
                  onChange={(value) =>
                    setNewProduct({ ...newProduct, quantite: value })
                  }
                  className="w-full border p-2.5 rounded"
                />
              </div>
              <div className="flex-grow space-y-1">
                <label htmlFor="seuil">Quantité seuil</label>
                <NumberInput
                  id="seuil"
                  name="seuil"
                  value={newProduct.seuil}
                  onChange={(value) =>
                    setNewProduct({ ...newProduct, seuil: value })
                  }
                  className="w-full border p-2.5 rounded"
                />
              </div>
            </div>
            <div className="space-y-1">
              <label htmlFor="unite">Unité de mesure</label>
              <input
                type="text"
                id="unite"
                name="unite"
                value={newProduct.unite}
                onChange={(e) =>
                  setNewProduct({ ...newProduct, unite: e.target.value })
                }
                className="w-full border p-2.5 rounded"
              />
            </div>
            <div className="space-y-1">
              <label htmlFor="prix_achat">Prix d'achat</label>
              <input
                id="prix_achat"
                name="prix_achat"
                value={newProduct.prix_achat}
                onChange={(e) =>
                  setNewProduct({
                    ...newProduct,
                    prix_achat: e.target.value,
                  })
                }
                className="w-full border p-2.5 rounded"
              />
            </div>
            <div className="space-y-1">
              <label htmlFor="prix_vente_emporte">Prix de vente emporté</label>
              <input
                id="prix_vente_emporte"
                name="prix_vente_emporte"
                value={newProduct.prix_vente_emporte}
                onChange={(e) =>
                  setNewProduct({
                    ...newProduct,
                    prix_vente_emporte: e.target.value,
                  })
                }
                className="w-full border p-2.5 rounded"
              />
            </div>
            <div className="space-y-1">
              <label htmlFor="prix_vente_sur_place">
                Prix de vente sur place
              </label>
              <input
                id="prix_vente_sur_place"
                name="prix_vente_sur_place"
                value={newProduct.prix_vente_sur_place}
                onChange={(e) =>
                  setNewProduct({
                    ...newProduct,
                    prix_vente_sur_place: e.target.value,
                  })
                }
                className="w-full border p-2.5 rounded"
              />
            </div>
            <Dropzone />
            <div className="flex gap-4">
              <button
                type="button"
                onClick={() => window.history.back()}
                className="py-2.5 px-5 ms-3 text-sm font-medium focus:outline-none bg-gray-100 rounded-lg border-2 border-gray-700 hover:bg-gray-700 text-gray-700 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-100 flex-grow text-center"
              >
                Annuler
              </button>
              <button
                type="submit"
                className="flex-grow bg-amber-500 text-white p-2 rounded hover:bg-amber-600"
              >
                Mettre à jour
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
